import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Practitioner } from 'src/app/shared/models/practitioner.model';
import { PractitionerService } from 'src/app/shared/services/practitioner.service';

@Component({
  selector: 'app-practitioner-edit-photo',
  templateUrl: './practitioner-edit-photo.component.html',
  styleUrls: ['./practitioner-edit-photo.component.scss']
})
export class PractitionerEditPhotoComponent implements OnInit {
  formGroup: FormGroup;
  profileImage: File;
  profileImageUrl: string | ArrayBuffer;

  @Input() isLoading: boolean;
  @Input() practitioner: Practitioner;
  @Output() dismissed = new EventEmitter<void>();
  @Output() submitted = new EventEmitter<FormGroup>();

  get profileImageSrc(): string | ArrayBuffer {
    if (this.profileImageUrl) {
      return this.profileImageUrl;
    }

    return this.practitioner.profileImage;
  }

  constructor(private practitionerService: PractitionerService) { }

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      'profileImage': new FormControl(null, Validators.required)
    });
  }

  getImage(event: any) {
    if (event.target.files.length === 0) { return; }

    var reader = new FileReader();
    this.profileImage = event.target.files[0];
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.profileImageUrl = reader.result;
    }
  }

  onSubmit(): void {
    if (!this.formGroup.valid) { return; }

    this.isLoading = true;
    this.practitionerService.uploadProfileImage(this.practitioner.uid, this.profileImage).then(url => {
      let finalFormGroup: FormGroup = new FormGroup({
        'profileImage': new FormControl(url)
      });
      finalFormGroup.get('profileImage').markAsDirty();
      this.submitted.emit(finalFormGroup);
    }).catch(error => {
      this.isLoading = false;
      alert(error);
    });
  }

  onDismiss(): void {
    this.dismissed.emit();
  }
}
